import { Component, Inject, OnInit, EventEmitter, Output } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'script-preferences-dialog',
  templateUrl: './script-preferences-dialog.component.html',
  styleUrls: ['./script-preferences-dialog.component.scss'],
  standalone: false,
})
export class ScriptPreferencesDialogComponent implements OnInit {
  title: string;
  body: string;
  @Output() onConfirm = new EventEmitter<void>();
  constructor(
    public dialogRef: MatDialogRef<ScriptPreferencesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  ngOnInit(): void {
    this.title = this.data?.title ?? '';
    this.body = this.data?.body ?? '';
  }

  confirm(event: Event): void {
    this.dialogRef.close(true);
  }
}
